/**
 * Download the canvas as image
 * @param canvas - the canvas element
 * @param imageName - the downloaded image name
 */
export const downloadImage = (canvas: HTMLCanvasElement, imageName = 'image') => {
  const link = document.createElement('a');
  link.download = `${imageName}.png`;
  link.setAttribute('href', canvas.toDataURL('image/png'));
  link.click();
};
